import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';
import { mediaQueryBreakpointMD } from '../Utils/Utils';
Swiper.use([Navigation, Pagination]);

const ACFBlockVideoSlideshow = (blockElem) => {

	//
	// Set up the slideshow
	new Swiper(blockElem.querySelector('.swiper'), {
		direction: 'horizontal',
		slidesPerView: 1,
		centeredSlides: false,

		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},

		pagination: {
			el: '.swiper-pagination',
			type: 'fraction',
			clickable: false,

			renderFraction: function (currentClass, totalClass) {
				return '<span class="' + currentClass + '"></span><span>/</span>' + '<span class="' + totalClass + '"></span>'; }
		},

		breakpoints: {
			[mediaQueryBreakpointMD]: {
				slidesPerView: 2,
				loop: false,
				spaceBetween: (blockElem.querySelectorAll('.swiper-slide').length > 1 ? -40 : 0),
			},
		}
	});

	//
	// Set up the videos
	const videos = blockElem.querySelectorAll('.video');
	videos.forEach((video) => {

		const placeHolder = video.querySelector('.placeholder');
		if(placeHolder) {
			const src = placeHolder.getAttribute('data-src');
			if(src) {
				const poster = video.querySelector('.poster');
				poster.addEventListener('click', (e) => {
					e.preventDefault();

					let videoEl;

					if(!video.classList.contains('js-initialised')) {

						videoEl = document.createElement('video');
						videoEl.src = src;
						videoEl.playsInline = true;
						videoEl.controls = true;
						videoEl.addEventListener('ended', () => video.classList.remove('js-playing'));

						placeHolder.appendChild(videoEl);

						video.classList.add('js-initialised');
					}
					else {
						videoEl = video.querySelector('video');
					}

					videoEl.play();
					video.classList.add('js-playing');
				});
			}
		}
	});
};

export default ACFBlockVideoSlideshow;